/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Virtual-token entry config as returned in API responses.
 * @export
 * @interface TokenEntryConfigResponse
 */
export interface TokenEntryConfigResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof TokenEntryConfigResponse
     */
    acceptedNftTrackerIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TokenEntryConfigResponse
     */
    acceptedNftGroupingId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TokenEntryConfigResponse
     */
    acceptsUniversalToken?: boolean;
}

/**
 * Check if a given object implements the TokenEntryConfigResponse interface.
 */
export function instanceOfTokenEntryConfigResponse(value: object): value is TokenEntryConfigResponse {
    return true;
}

export function TokenEntryConfigResponseFromJSON(json: any): TokenEntryConfigResponse {
    return TokenEntryConfigResponseFromJSONTyped(json, false);
}

export function TokenEntryConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenEntryConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptedNftTrackerIds': json['acceptedNftTrackerIds'] == null ? undefined : json['acceptedNftTrackerIds'],
        'acceptedNftGroupingId': json['acceptedNftGroupingId'] == null ? undefined : json['acceptedNftGroupingId'],
        'acceptsUniversalToken': json['acceptsUniversalToken'] == null ? undefined : json['acceptsUniversalToken'],
    };
}

export function TokenEntryConfigResponseToJSON(json: any): TokenEntryConfigResponse {
    return TokenEntryConfigResponseToJSONTyped(json, false);
}

export function TokenEntryConfigResponseToJSONTyped(value?: TokenEntryConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'acceptedNftTrackerIds': value['acceptedNftTrackerIds'],
        'acceptedNftGroupingId': value['acceptedNftGroupingId'],
        'acceptsUniversalToken': value['acceptsUniversalToken'],
    };
}

